import React from "react";
import CompleteStripeConnect from "components/CompleteStripeConnect";
import Button from "components/Form/fields/Button";
import { getStripeDestination } from "utils/stripe";
import { MERCHANT_ACCOUNT_AUTH_ACTION } from "utils/constants/merchantAccount";
import { STRIPE_ROUTES } from "utils/constants/stripe";
import ResetStripeConnect from "components/ResetStripeConnect";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import { useAccountConnectStatusProps } from "utils/selectors";
import { useLoginWithStripe } from "utils/state";

/**
 * 1. Complete with connect
 * - Business details are not yet submitted for a deferred account
 * 2. Review on dashboard
 * - Business details are submitted but charges are not yet enabled for the applying account
 * - Progress can be reviewed on Stripe dashboard
 * 3. Reauth
 * - Account has been verified but an additional re-authentication is required so that api keys can be refreshed
 */
const StripeConnectActions = () => {
  const loginWithStripe = useLoginWithStripe();

  const { serviceUid, authAction, cta, uuid } = useAccountConnectStatusProps();

  if (authAction === MERCHANT_ACCOUNT_AUTH_ACTION.COMPLETE_WITH_CONNECT) {
    return (
      <div className="flex flex-column flex-row-ns">
        <CompleteStripeConnect
          theme="slim"
          copy="Verify account"
          account={serviceUid}
          merchantAccountUUID={uuid}
          classes={{
            contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
          }}
        />
        <div className="dib pt2 mt2 pt0-ns mt0-ns ml2-ns pl2-ns bl-ns hairline-1">
          <ResetStripeConnect />
        </div>
      </div>
    );
  } else if (authAction === MERCHANT_ACCOUNT_AUTH_ACTION.REVIEW_ON_DASHBOARD) {
    return (
      <Button
        copy={cta}
        tag="a"
        theme="slim"
        target="_blank"
        href={getStripeDestination({
          path: STRIPE_ROUTES.UPDATE,
          test: false
        })}
      />
    );
  } else if (authAction === MERCHANT_ACCOUNT_AUTH_ACTION.REAUTH) {
    return <Button copy={cta} tag="a" theme="slim" href={loginWithStripe} />;
  }

  return null;
};

export default StripeConnectActions;
